import React, {useState, useEffect} from "react";
import RequestHelper from "src/Lib/Helper/RequestHelper";
import BioSpinner from "src/RCMP/BioSpinner";
import {toast} from "react-toastify";
import {useAuthentication} from "src/Lib/Provider/RACT_authProvider";
import LanguageSelector from "src/RCMP/RCMP_formConstrolReg_V00.04/BioLanguageSelector";
import LocationSelector from "src/RCMP/RCMP_formConstrolReg_V00.04/BioLocationSelector";


const RegisterFormStep4 = ({email, password, code, onDone, back}) => {
    const [loader, setLoader] = useState(false);
    const {signInByObj} = useAuthentication();
    const [formData, setFormData] = useState({
        age: "",
        sex: "",
        language: "",
        languageId: "",
        country: "",
        countryId: "",
        state: "",
        city: "",
        cityId: "",
    });

    const handleInputChange = (event) => {
        const {name, value} = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });

    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const {age, sex, languageId, countryId, stateId, cityId} = formData;
        if (!age || !sex || !languageId || !countryId || !stateId || !cityId) {
            toast.error("Please fill in all fields before proceeding.");
            return;
        }

        setLoader(true);
        try {
            const res = await RequestHelper.post("NPAN_TSESSION", "/fill", {...formData, code, email, password});
            setLoader(false);

            if (res.success) {
                toast.success("Registration completed successfully!");
                signInByObj(res.object);
                onDone();
            } else {
                toast.error(res.message || "Failed to complete registration.");
            }
        } catch (error) {
            setLoader(false);
            toast.error("An error occurred while submitting the form.");
        }
    };

    return (
        <div className="w-100 py-5">
            <form
                className="bg-gray-200 pb-4 rounded-lg px-3 max-w-full w-[400px] shadow-lg mx-auto"
                onSubmit={handleSubmit}
            >
                <div className="flex flex-col px-3 py-4 items-center gap-2 content-center">
                    <h1 className="font-bold font-20">Complete Your Profile</h1>
                </div>
                <div className="flex flex-col w-full items-start gap-3 font-14 content-start py-2">
                    <label className="w-full text-start">Age:</label>
                    <input
                        type="number"
                        name="age"
                        value={formData.age}
                        onChange={handleInputChange}
                        required
                        max={120}
                        min={1}
                        className="border w-full rounded-md px-3 py-2"
                    />

                    <label className="w-full text-start">Sex:</label>
                    <select
                        name="sex"
                        value={formData.sex}
                        onChange={handleInputChange}
                        required
                        className="border w-full rounded-md px-3 py-2"
                    >
                        <option value="">Select</option>
                        <option value="2">Male</option>
                        <option value="1">Female</option>
                        <option value="3">Other</option>
                    </select>


                    <LanguageSelector inputClass="border w-full rounded-md px-3 py-2" labelClass="w-full text-start"
                                      params={formData} setParams={setFormData}/>
                    <LocationSelector inputClass="border w-full rounded-md px-3 py-2" labelClass="w-full text-start"
                                      params={formData} setParams={setFormData}/>
                </div>

                <div className="flex gap-2 w-full my-4 flex-row">
                    <button
                        type="button"
                        onClick={back}
                        className="border border-black text-black justify-center items-center flex w-full w-100 rounded-md py-2 px-5"
                        disabled={loader}
                    >
                        {loader ? <BioSpinner animation="border" size="sm"/> : <span>Back</span>}
                    </button>
                    <button
                        className="bg-black justify-center items-center flex w-full text-white w-100 rounded-md py-2 px-5"
                        disabled={loader}
                    >
                        {loader ? <BioSpinner animation="border" size="sm"/> : <span>Submit</span>}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default RegisterFormStep4;